import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './MainApp';
import { AuthProvider } from './auth';
import { FarmerAuthProvider } from './farmerAuth';
import { GrowItLanding } from './components/GrowItLanding';
import './index.css';

const isGrowItLanding = window.location.pathname === '/growit' || window.location.pathname === '/growit/';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isGrowItLanding ? <GrowItLanding /> : (
      <AuthProvider>
        <FarmerAuthProvider>
          <App />
        </FarmerAuthProvider>
      </AuthProvider>
    )}
  </React.StrictMode>,
);
